export default "__VITE_ASSET__pzEbvOXz__"